<ul>
  <li><strong>share: </strong>{{ translationPrefix() + 'share' | translate }}</li>
  <li><strong>name: </strong>{{ translationPrefix() + 'name' | translate }}</li>
  <li><strong>purchase_date: </strong>{{ translationPrefix() + 'purchase_date' | translate }}</li>
  <li><strong>purchase_price: </strong>{{ translationPrefix() + 'purchase_price' | translate }}</li>
  <li><strong>purchase_currency: </strong>{{ translationPrefix() + 'purchase_currency' | translate }}</li>
</ul>
